import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { api } from "@/lib/auth-context";
import { useAuth } from "@/lib/auth-context";

function routeByRole(user) {
  if (!user) return "/";
  if (user.role === "admin") return "/admin/dashboard";
  if (user.role === "attorney" || user.role === "law_firm") {
    if (user.status !== "approved") return "/pending";
    if (
      user.subscription_status !== "active" &&
      user.subscription_status !== "trialing"
    )
      return "/billing";
    return "/attorney/dashboard";
  }
  return "/";
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {
          session_id: sessionId,
        });
        // Clear hash before nav so we don't loop
        window.history.replaceState(null, "", window.location.pathname);
        await refreshUser();
        navigate(routeByRole(data.user), { replace: true });
      } catch (e) {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refreshUser]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-[#F8FAFC]"
    >
      <Loader2 className="w-6 h-6 animate-spin text-[#0A192F]" />
    </div>
  );
}
